














import modalMixin from "@/mixins/modal.ts";
import vMatch from './match.vue';
import { Component, Vue, Emit } from 'vue-property-decorator';

@Component({
  components: {
    vMatch
  },
  mixins: [ modalMixin ]
})
export default class VOpenMatch extends Vue {

  // @Emit()
  ok() {
    this.$emit('update:value', false);
  }
}
